"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext } from "react";
import type { EditorBackend } from "./types";
import { realEditorBackend } from "./real-editor-backend";

/**
 * Default value IS the real backend — so the authenticated editor works with
 * zero provider wiring. Only the `/try` demo wraps its subtree with a provider
 * that supplies `demoEditorBackend`.
 */
const EditorBackendContext = createContext<EditorBackend>(realEditorBackend);
export function EditorBackendProvider(t0) {
  const $ = _c(3);
  const {
    backend,
    children
  } = t0;
  let t1;
  if ($[0] !== backend || $[1] !== children) {
    t1 = <EditorBackendContext.Provider value={backend}>{children}</EditorBackendContext.Provider>;
    $[0] = backend;
    $[1] = children;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}

/** Access the active editor backend (real by default, demo inside `/try`). */
export function useEditorBackend() {
  return useContext(EditorBackendContext);
}